import React from "react";
import "./AppSpinner.css";

import PlatformLogo from "./PlatformLogo";

const AppSpinner = ({ options }) => {
  // const { appName } = useParams();
  return (
    <div className="container-spinner">
      <div className="separator"></div>
      {options.appInitials && (
        <div className="app-initials">
          <span>{options.appInitials}</span>
        </div>
      )}
      <div className="app-name">{options.appname}</div>
      <div className="loading">
        <span>&#183;</span>
        <span>&#183;</span>
        <span>&#183;</span>
      </div>
      <div className="separator"></div>
      {options.showPlatformLogo && (
        <PlatformLogo
          className="logo"
          appName={options.platformName}
          logoImgUrl={options.fileUrl}
        />
      )}
    </div>
  );
};

export default AppSpinner;
